import React, { Component } from "react";
import styles from "./controlPoints.module.scss";
import ViewPanelRadioControl from "./ViewPanelRadioControl";
import ControlPointsList from "./ControlPointsList";
import CreateControlPoint from "./CreateControlPoint";
import GroupsControlPoints from "./GroupsControlPoints";
import FilterAndSearchTools from "../FilterTools/FilterAndSearchTools";
import { withLogisticControlPoints } from "../../../shared/containers/containerLogisticControlPoints";

const viewPanelItems = {
  controlPointsList: "controlPointsList",
  groupsControlPoints: "groupsControlPoints",
  createControlPoint: "createControlPoint",
};

class ControlPoints extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewPanel: viewPanelItems.controlPointsList,
    };
  }

  onSetViewPanel(viewPanel) {
    this.setState({ viewPanel });
  }

  render() {
    const { viewPanel } = this.state;
    const { onGetControlPoints } = this.props;
    const setViewPanel = this.onSetViewPanel.bind(this);

    return (
      <div className={styles.controlPointsPanelContainer}>
        {viewPanel !== viewPanelItems.createControlPoint ? (
          <div>
            <ViewPanelRadioControl viewPanel={viewPanel} viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} />
          </div>
        ) : null}

        {viewPanel !== viewPanelItems.createControlPoint ? <FilterAndSearchTools onFilter={onGetControlPoints} /> : null}

        {viewPanel === viewPanelItems.controlPointsList ? (
          <ControlPointsList viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} />
        ) : null}

        {viewPanel === viewPanelItems.groupsControlPoints ? (
          <GroupsControlPoints viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} />
        ) : null}

        {viewPanel === viewPanelItems.createControlPoint ? (
          <CreateControlPoint viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} />
        ) : null}
      </div>
    );
  }
}

export default withLogisticControlPoints(React.memo(ControlPoints));
